var map = {
	"./1-removebg-preview.png": 81774,
	"./10-removebg-preview.png": 36475,
	"./102-removebg-preview.png": 18382,
	"./105-removebg-preview.png": 25942,
	"./107-removebg-preview.png": 48782,
	"./111-removebg-preview.png": 18064,
	"./115-removebg-preview.png": 79593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37555;